var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableIconActionDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_344_131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5834 2.83333H12.0417V1.41667C12.0417 1.04094 11.8925 0.680609 11.6268 0.414932C11.3611 0.149256 11.0008 0 10.6251 0L6.37508 0C5.99936 0 5.63902 0.149256 5.37335 0.414932C5.10767 0.680609 4.95841 1.04094 4.95841 1.41667V2.83333H1.41675V4.25H2.83341V14.875C2.83341 15.4386 3.0573 15.9791 3.45581 16.3776C3.85433 16.7761 4.39483 17 4.95841 17H12.0417C12.6053 17 13.1458 16.7761 13.5444 16.3776C13.9429 15.9791 14.1667 15.4386 14.1667 14.875V4.25H15.5834V2.83333ZM6.37508 1.41667H10.6251V2.83333H6.37508V1.41667ZM12.7501 14.875C12.7501 15.0629 12.6755 15.243 12.5426 15.3759C12.4098 15.5087 12.2296 15.5833 12.0417 15.5833H4.95841C4.77055 15.5833 4.59039 15.5087 4.45755 15.3759C4.32471 15.243 4.25008 15.0629 4.25008 14.875V4.25H12.7501V14.875Z",
    fill: "#FF3B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79166 7.0829H6.375V12.7496H7.79166V7.0829Z",
    fill: "#FF3B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6252 7.0829H9.2085V12.7496H10.6252V7.0829Z",
    fill: "#FF3B30"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_344_131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableIconActionDelete);
export default __webpack_public_path__ + "static/media/table_icon_action_delete.f6665f75c656faf273c0d07bdaee04ae.svg";
export { ForwardRef as ReactComponent };